// Session-token storage. localStorage survives refresh (POC UX). The token is an opaque session
// id (server-side state in KV), so theft via XSS is mitigated by short TTL + server-side revoke;
// hardening to in-memory + silent refresh is a follow-up.
const KEY = 'pavlov_session';

export const tokenStorage = {
  get: (): string | null => {
    try {
      return localStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  set: (token: string): void => {
    try {
      localStorage.setItem(KEY, token);
    } catch {
      /* ignore */
    }
  },
  clear: (): void => {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
};
